import api from '../Api';
import { BaseService } from '../BaseService';
import { InssMarginClientForm, InssMarginTab } from '../../models/InssMargin/InssMarginModels';

const PREFIX = 'simulation/inss-margin';

export class InssMarginService extends BaseService {
    async getFinancials(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${PREFIX}/financials`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async getDiscardReasons(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${PREFIX}/discard-reasons`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async list(params: { tab: InssMarginTab; page: number; perPage: number; search?: string }): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${PREFIX}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async getRecord(cpf: string): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${PREFIX}/clients/${cpf}/record`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async validate(opportunityId: string): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${PREFIX}/opportunities/${encodeURIComponent(opportunityId)}/validate`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async updateClient(cpf: string, form: InssMarginClientForm): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${PREFIX}/clients/${cpf}/update`, form));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async setFinancials(opportunityId: string, financials: string[]): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${PREFIX}/opportunities/${encodeURIComponent(opportunityId)}/financials`, { financials }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async discard(opportunityId: string, reason: string, note?: string): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${PREFIX}/opportunities/${encodeURIComponent(opportunityId)}/discard`, { reason, note }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async restore(opportunityId: string): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${PREFIX}/opportunities/${encodeURIComponent(opportunityId)}/restore`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}